import { ISleepStage } from "./types";

export const SleepStage = {
  NO_PRESENCE: "5",
  AWAKE: "4",
  REM: "3",
  LIGHT: "2",
  DEEP: "1",
  UNKNOWN: "0",
} as const;

export const sleepStageOrder: ISleepStage[] = [
  SleepStage.DEEP,
  SleepStage.LIGHT,
  SleepStage.REM,
  SleepStage.AWAKE,
  SleepStage.NO_PRESENCE,
];
